module.exports = __webpack_public_path__ + "static/media/img_forest.96b79345.png";